/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissingwebsite3Inputs */

const en_listingbuttonsmissingwebsite3 = /** @type {(inputs: Listingbuttonsmissingwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No website –`)
};

const de_listingbuttonsmissingwebsite3 = /** @type {(inputs: Listingbuttonsmissingwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Website –`)
};

/**
* | output |
* | --- |
* | "No website –" |
*
* @param {Listingbuttonsmissingwebsite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissingwebsite3 = /** @type {((inputs?: Listingbuttonsmissingwebsite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissingwebsite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissingwebsite3(inputs)
	return de_listingbuttonsmissingwebsite3(inputs)
});
export { listingbuttonsmissingwebsite3 as "listingButtonsMissingWebsite" }